import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import CustomStore from 'devextreme/data/custom_store';
import { ToastService } from 'ng-uikit-pro-standard';
import { EmployeesService } from 'src/app/services/employees.service';
import { OpenRifService } from 'src/app/services/open-rif.service';
import { TaskService } from 'src/app/services/task.service';
import { AppConfigService } from 'src/app/app-config.service.service';

@Component({
  selector: 'app-new-rfi',
  templateUrl: './new-rfi.component.html',
  styleUrls: ['./new-rfi.component.scss']
})
export class NewRfiComponent implements OnInit {
  // @Input() projectInfo: any;
  @Input() projectid: any;
  private _projectInfo: any;

  @Input('projectInfo')
  set projectInfo(projectInfo: any) {
    this._projectInfo = projectInfo;

    if (this.newRFI && projectInfo) {
      this.newRFI.get('Project').setValue(projectInfo.ID + '-'+projectInfo.NAME);
      this.hasproject = true;
    }
    // if (projectInfo && projectInfo.projectInfoid > 0)
    // this.setprojectInfoInfo(projectInfo);
  }

  get projectInfo(): any { return this._projectInfo; }


  @Input() popupnewRFI = false;
  @Output() onmodalhidden = new EventEmitter<any>();
  @Output() onsubmit = new EventEmitter<any>();

  newRFI: FormGroup;
  sentTo: any;
  idSentTo: any;
  millisecondsInDay = 24 * 60 * 60 * 1000;
  today= new Date().getTime();
  dataRfi: Array<any>;
  createdBy: any;
  priority: Array<any> = [{id: 1 , name:'High'},  {id: 2, name: 'Normal'}, {id: 3, name:'Low'} ];
  rfiDate = {todayButton: {}, prevDateButton: {}, nextDateButton: {}, showDate: this.today};
  respondedByDate = {todayButton: {}, prevDateButton: {}, nextDateButton: {}, showDate: this.today};
  employees = [];
  projectslist: any;

  hasproject = false;

  cancelButton: any;
  saveButton: any;
  settings: any = {};
  constructor(
    private employeeService: EmployeesService,
    private openRif: OpenRifService,
    private toast: ToastService,
    private taskService: TaskService,
    private appconfig: AppConfigService

  ) {
    this.initRFI();
    this.settings.dateFormat = this.appconfig.dateFormat;
   }

  ngOnInit() {

    this.cancelButton = {
      text: 'Cancel',
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupnewRFI = false;
        this.onHidden();
      },
    };

    this.saveButton = {
      text: 'Save',
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        // this.type = 1;
        this.saveRFI();
      },
    };


    let mythis = this;
    this.projectslist = new CustomStore({
      key: "ID",
      load: function (loadOptions: any) {
        return mythis.taskService.GetProjectByName(loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });

    // this.popupnewRFI = true;
  }

  inputsDate(date){
    date.todayButton = {
      text: "Today",
      elementAttr: {
        id: 'today-Btn'
      },
      onClick: () => {
        date.showDate = new Date().getTime();
      }
    };

    date.prevDateButton = {
      icon: "spinprev",
      stylingMode: "text",
      onClick: () => {
        date.showDate -= this.millisecondsInDay;
      }
    };

    date.nextDateButton = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        date.showDate += this.millisecondsInDay;
      }
    };
  }

  updateProjectInfo(ev) {
    console.log(ev);
    if(ev.selectedItem)
      this.projectid = ev.selectedItem.ID;
    else
    this.projectid = 0;
  }

  onHidden() {
    this.popupnewRFI = false;
    this.onmodalhidden.emit();
    this.initRFI();
  }

  getEmployees(){
    this.employeeService.GetAll().subscribe(result=>{
      this.employees = result.map((val)=>{
        return {
          id: val.ID,
          name: val.FULLNAME
        }
      });
    })
  }

  getContacts(){
    this.openRif.GetContacts2().subscribe(result=>{
      this.sentTo = result;
    })
  }

  searchContact(nameContact){
    let found = this.sentTo.find(data=> data.First == nameContact);
    if(found!==undefined){ this.idSentTo = found.ID; }

  }

  initRFI(){
    let projectname = this.projectInfo ? this.projectInfo.ID + '-' + this.projectInfo.NAME : '';
    console.log(projectname);
    this.newRFI = new FormGroup ({
      Name: new FormControl('', [Validators.required]),
      Project: new FormControl(projectname, []),
      Number: new FormControl('', []),
      Date: new FormControl(new Date(), []),
      CreatedBy: new FormControl('', []),
      Priority: new FormControl('', [Validators.required]),
      Attachment: new FormControl('', []),
      SentTo: new FormControl('', [Validators.required]),
      RespondedBy: new FormControl(new Date(), []),
      Responded: new FormControl('', []),
      Description: new FormControl('', []),
      Response: new FormControl('', []),
    })
    this.inputsDate(this.rfiDate);
    this.inputsDate(this.respondedByDate);
    this.respondedByDate.showDate = new Date().getTime();
    this.getEmployees();
    this.getContacts();
  }

  saveRFI(){
    console.log(this.newRFI.value);
    let form = this.newRFI.value;
    let needresponse;
    form.Responded == true ? needresponse = 1 : needresponse = 0;


    if(!this.projectid) {
      this.toast.success('Please enter project name');
      return;
    }
    if(!form.Name) {
      this.toast.warning('Please enter RFI name');
      return;
    }
    if(!form.Priority) {
      this.toast.warning('Please enter a Priority');
      return;
    }
    if(!form.SentTo) {
      this.toast.warning('Please enter a Contact');
      return;
    }

    if(!this.projectid) {
      this.toast.warning('Please enter project name');
      return;
    }
    form.Date = new Date(form.Date);
    console.log(form.Date);
    form.RespondedBy = new Date(form.RespondedBy);

    this.openRif.InsertRfi(form.Name,
      form.Number,
      this.projectid,
      form.Date,
      this.idSentTo,
      form.Priority,
      form.CreatedBy,
      form.RespondedBy,
      needresponse,
      form.Response,
      form.Description,
      0 )
    .subscribe(result=>{
      console.log(result);
      this.popupnewRFI = false;
      // this.datagrid.reloadComponent();
      // this.getAllRFI();
      this.toast.success('The RFI Detail information has been saved successfully');
      this.newRFI.reset();
      this.initRFI();
      this.onsubmit.emit();
    })
  }

}
